// extracted by mini-css-extract-plugin
export default {"link":"footer-link_link__onUbQ","element":"footer-link_element__PDEWn"};